module.exports = __webpack_public_path__ + "img/Equipa_PS_2.aaa48841.png";